import { Link, Navigate } from 'react-router-dom';
import { BUSINESS, getLegalPage } from './legalContent';
import './LegalPage.scss';

const NAV_LINKS = [
  { key: 'about', to: '/about', label: 'About' },
  { key: 'contact', to: '/contact', label: 'Contact' },
  { key: 'terms', to: '/terms', label: 'Terms' },
  { key: 'privacy', to: '/privacy', label: 'Privacy' },
  { key: 'refund', to: '/refund-policy', label: 'Refunds' },
  { key: 'shipping', to: '/shipping-policy', label: 'Shipping' },
];

function LegalPageBody({ pageKey, page }) {
  return (
    <div className="legal-page">
      <div className="legal-page__inner">
        <h1 className="legal-page__title">{page.title}</h1>
        <p className="legal-page__updated">Last updated: {BUSINESS.lastUpdated}</p>

        <nav className="legal-page__nav" aria-label="Legal pages">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={link.key === pageKey ? 'is-active' : undefined}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="legal-page__content">
          {page.sections.map((section) => (
            <section key={section.heading} className="legal-page__section">
              <h2>{section.heading}</h2>
              {(section.paragraphs || []).map((p, i) => (
                <p key={`${section.heading}-p-${i}`}>{p}</p>
              ))}
              {section.contacts?.length > 0 && (
                <div className="legal-page__contacts">
                  {section.contacts.map((c) => (
                    <a key={c.href} className="legal-page__contact" href={c.href}>
                      <span className="legal-page__contact-label">{c.label}</span>
                      <span className="legal-page__contact-value">{c.value}</span>
                    </a>
                  ))}
                </div>
              )}
              {section.bullets?.length > 0 && (
                <ul>
                  {section.bullets.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              )}
              {(section.paragraphsAfter || []).map((p, i) => (
                <p key={`${section.heading}-pa-${i}`}>{p}</p>
              ))}
            </section>
          ))}
        </div>

        <p className="legal-page__footnote">
          These pages are provided for transparency and for payment-partner requirements.
          They are not a substitute for professional legal advice.
        </p>
      </div>
    </div>
  );
}

/** Renders a legal page by key, e.g. pageKey="terms" */
export function LegalPage({ pageKey }) {
  const page = getLegalPage(pageKey);
  if (!page) return <Navigate to="/" replace />;
  return <LegalPageBody pageKey={pageKey} page={page} />;
}
